import React from 'react'
import { Text, Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import NewSvg from '@images/new.svg'

const TagStyle = {
  border: 'solid 0.5px #B8B8BD',
  px: 1,
  py: 0.5,
  borderRadius: 'sm',
}

export const NewTag = () => <Image src={buildAssetUrlString(NewSvg)} alt="New" w="100%" h="100%" />

export const FreeTag = () => <Text {...TagStyle}>無料あり</Text>

export const DiscountTag = () => <Text {...TagStyle}>割引あり</Text>

export const UnpurchasedContentTag = () => <Text {...TagStyle}>未購入巻あり</Text>

export const UnpurchasedNewContentTag = () => <Text {...TagStyle}>未購入新刊あり</Text>

export const NextReleaseDateTag = ({ releaseDate }) => <Text {...TagStyle}>{releaseDate}配信予定</Text>
